import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Customer } from '../../app/models/Customer';
import { Site } from '../../app/models/Site';
import { Entity } from '../../app/models/Entity';

@Component({
  selector: 'customer-hierachy-item',
  templateUrl: 'customer-hierachy-item.html'
})
export class CustomerHierachyItemComponent {

  @Input() customer: Customer;
  @Output() goToEntity =  new EventEmitter<Entity>(null);
  @Output() favoriteEvent = new EventEmitter<Customer>(null);

  constructor() {
  }

  toggleExpandCustomer(customer: Customer) {
    this.customer.expanded = !this.customer.expanded;
  }

  toggleExpandSite(site: Site) {
    site.expanded = !site.expanded;
  }

  goTo(entity: Entity) {
    this.goToEntity.emit(entity);
  }

  toggleFavorite() {
    this.favoriteEvent.emit(this.customer);
  }

}



// WEBPACK FOOTER //
// ./src/components/customer-hierachy-item/customer-hierachy-item.ts